import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useCustomerAuth } from '@/contexts/CustomerAuthContext';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export const Header: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, signOut } = useCustomerAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Sign out failed:', error);
    }
  };

  return (
    <header className="h-20 bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto h-20 px-4 flex items-center justify-between">
        <div className="flex items-center">
          <Link to="/" className="flex items-center" aria-label="CollectABILITY Home">
            <img
              src="/linear-logo-sm.png"
              alt="CollectABILITY"
              className="h-12"
              loading="eager"
              height={48}
            />
          </Link>
        </div>

        <nav className="hidden md:flex items-center gap-4">
          <Link to="/products" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">
            Products
          </Link>
          <Link to="/batch" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">
            Batch Processing
          </Link>
          <Link to="/search" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">
            Web Search
          </Link>
          <Link to="/contact" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">
            Contact Us
          </Link>
        </nav>

        <div className="flex items-center gap-2">
          {isAuthenticated ? (
            <>
              <Link to="/account" className="ca-btn ca-btn--primary">
                My Account
              </Link>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <button
                      onClick={handleSignOut}
                      className="ca-btn ca-btn--ghost h-9 px-2"
                      aria-label="Sign out"
                    >
                      <LogOut className="h-4 w-4" />
                    </button>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Sign out of your account</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </>
          ) : (
            <Link to="/auth" className="ca-btn ca-btn--primary">
              Sign In / Sign Up
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
